export const isLanguageType = (value: any): boolean => {
  return value === "da" || value === "en";
};